import { usePermissions } from '@/shared/permissions';

import { LOYALTY_PERMISSIONS } from '../model/permissions';

export interface LoyaltyPermissions {
  /** Read bonus accounts, transactions, cards, tiers and rules. */
  canView: boolean;
  /** Accrue/redeem points, issue cards, configure the programme. */
  canManage: boolean;
}

/** Resolves the loyalty permission flags from the session permissions. */
export function useLoyaltyPermissions(): LoyaltyPermissions {
  const { hasPermission } = usePermissions();
  return {
    canView: hasPermission(LOYALTY_PERMISSIONS.loyalty.view),
    canManage: hasPermission(LOYALTY_PERMISSIONS.loyalty.manage),
  };
}
